import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Layout } from 'antd';
import NavBar from './NavBar'
import MyFooter from './MyFooter';

const { Header, Content, Footer } = Layout;

export default function MainContainer({actived,children}) {

    return (
        <Layout style={{ display: "flex", flexDirection: "AColumn", height: "100%", background: "#F0F2F5" }}>

            <Header style={{ padding: '0 5vw', flex: "0 0 auto", position: 'fixed', zIndex: 10, width: '100%' }}>
                <NavBar actived={actived} />
            </Header>

            <Content style={{ padding: '0 5vw', flex: "1 0 auto", background: "#F0F2F5" }}>
                <Row wrap>
                    <Col flex="auto"></Col>
                    <Col flex="1560px" >
                        <div style={{ height: "100px" }} />
                        <div className="site-layout-content">
                            <>
                                <Card className='segment'>
                                    {
                                        children
                                    }
                                </Card>
                            </>
                        </div>
                    </Col>
                    <Col flex="auto"></Col>
                </Row>
            </Content>

            <Footer style={{ padding: '0 5vw', flex: "0 0 auto", textAlign: 'center', background:"#f0f2f5" }}>
                <MyFooter />
            </Footer>

        </Layout>
    )
}
